<p-toast
  key="app-toast"
  position="top-right"
  [baseZIndex]="300000"
  [autoZIndex]="true"
  showTransformOptions="translateX(100%)"
  hideTransformOptions="translateX(100%)"
  showTransitionOptions="300ms cubic-bezier(0, 0, 0.2, 1)"
  hideTransitionOptions="200ms cubic-bezier(0.4, 0, 1, 1)"
  appendTo="body"
>
  <ng-template #message let-message>
    <div class="p-toast-message-text">
      @if (message.summary) {
        <div class="p-toast-summary" [innerHTML]="message.summary"></div>
      }
      @if (message.detail) {
        <div class="p-toast-detail" [innerHTML]="message.detail"></div>
      }
    </div>
  </ng-template>
</p-toast>

<p-confirmdialog
  key="app-confirm-dialog"
  styleClass="app-confirm-dialog"
  [baseZIndex]="210000"
  [autoZIndex]="true"
  appendTo="body"
  [dismissableMask]="false"
  [closeOnEscape]="false"
  (onHide)="confirmDialogService.onDialogHide()"
>
  <ng-template pTemplate="message" let-message>
    <div
      class="min-w-0 whitespace-normal wrap-break-word text-sm leading-6 text-gray-700 dark:text-gray-200"
      [innerHTML]="message?.message"
    ></div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex items-center justify-end">
      @if (confirmDialogService.rejectVisible()) {
        <app-button
          variant="outline"
          [disabled]="confirmDialogService.isExecuting()"
          [className]="confirmDialogService.acceptVisible() ? 'rounded-r-none' : ''"
          (btnClick)="confirmDialogService.reject()"
        >
          <span #startIcon startIcon class="pi pi-times"></span>
          {{ confirmDialogService.rejectLabel() }}
        </app-button>
      }

      @if (confirmDialogService.acceptVisible()) {
        <app-button
          variant="system"
          [loading]="confirmDialogService.isExecuting()"
          [disabled]="confirmDialogService.isExecuting()"
          [className]="confirmDialogService.rejectVisible() ? 'rounded-l-none -ml-px' : ''"
          (btnClick)="confirmDialogService.accept()"
        >
          @if (!confirmDialogService.isExecuting()) {
            <span #startIcon startIcon class="pi pi-check"></span>
          }
          {{ confirmDialogService.acceptLabel() }}
        </app-button>
      }
    </div>
  </ng-template>
</p-confirmdialog>

<router-outlet></router-outlet>


